var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('main-loader',{staticClass:"pt-5"}):_c('wat-sew-collisions-info',{attrs:{"title-path":"sidebar.fixedAssets.collisionsTitle","custom-collisions-trees":_vm.collisionsTrees,"custom-collisions-trees-counts":_vm.collisionsTreesCounts,"hover-color":"255,0,0","tabs":_vm.tabs,"hide-buffer":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }